import React from 'react';

export const NxIcon = {
  arrowRight: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7h8M8 4l3 3-3 3" /></svg>
  ),
  arrowLeft: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M11 7H3M6 4L3 7l3 3" /></svg>
  ),
  upload: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M7 9V2M4 5l3-3 3 3M2 11h10" /></svg>
  ),
  check: (c = 'currentColor') => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2.5 6.5l2.5 2.5 5-6" /></svg>
  ),
  clock: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.5"><circle cx="7" cy="7" r="5.5" /><path d="M7 4v3.2L9 8.5" /></svg>
  ),
  flag: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 2v11M3 3h7l-1.5 2.5L10 8H3" /></svg>
  ),
  info: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.5"><circle cx="7" cy="7" r="5.5" /><path d="M7 6v4M7 4v.01" strokeLinecap="round" /></svg>
  ),
  power: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round"><path d="M5 3a5 5 0 1 0 4 0M7 2v5" /></svg>
  ),
  shield: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.5" strokeLinejoin="round"><path d="M7 1.5L2 3.5v3.7c0 3 2.2 5.4 5 5.8 2.8-.4 5-2.8 5-5.8V3.5L7 1.5z" /></svg>
  ),
  chevronDown: (c = 'currentColor') => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round"><path d="M2.5 4.5L6 8l3.5-3.5" /></svg>
  ),
  calendar: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.4"><rect x="1.5" y="3" width="11" height="9.5" rx="1.5" /><path d="M4 1.5v2.5M10 1.5v2.5M1.5 6h11" /></svg>
  ),
  doc: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2.5 2h8a1 1 0 0 1 1 1v9.5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a1 1 0 0 1 1-1z" /><path d="M8 2v2a1 1 0 0 0 1 1h2" /></svg>
  ),
  logout: (c = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.5H2.5a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1H5M9.5 10l3-3-3-3M12.5 7H5" /></svg>
  ),
  eye: (c = 'currentColor') => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={c} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M1 8s2.5-4.5 7-4.5S15 8 15 8s-2.5 4.5-7 4.5S1 8 1 8z" /><circle cx="8" cy="8" r="2" /></svg>
  ),
  eyeOff: (c = 'currentColor') => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={c} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M6.3 3.2A6.5 6.5 0 0 1 8 3c4.5 0 7 5 7 5a12 12 0 0 1-1.9 2.5M3.6 4.6A12 12 0 0 0 1 8s2.5 5 7 5a6.4 6.4 0 0 0 2.7-.6M6.6 6.6a2 2 0 0 0 2.8 2.8M1.5 1.5l11 11" /></svg>
  ),
};
